import React from "react";
import TBD from "../../TBD";

const User = () => {
  return <TBD />;
};

export default User;
